import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
export default styled.form(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));